import Cabinet from "./Cabinet";

export default Cabinet